<div class="next-heading">
	Upcoming Games
	<!-- <div class="bookie-ident">
		<img class="bookie-logo" alt="BetStreet" src="https://cdn.ciphersports.io/assets/betstreet-full-logo.svg">
	</div> -->
</div>
<app-sidebar-block *ngIf="sidebarConfig" [configurationObject]="sidebarConfig"></app-sidebar-block>